import { css } from "@emotion/react";
import { SvgIconComponent } from "@mui/icons-material";
import { Theme, useTheme } from "@mui/material";
import { match } from "ts-pattern";

import { Form } from "~/components/database/detail/database-content/types";
import { DatabaseDetailPageProps } from "~/pages/database/[id]";

const DIALOG_KINDS = ["share", "copy-link", "report", "cancel"] as const;

type MenuItem = {
  icon: SvgIconComponent;
  text: string;
  kind: (typeof DIALOG_KINDS)[number];
};

type OnClickHandler = (form: Form) => Promise<void>;

const share: OnClickHandler = async (form: Form) => {
  if (!navigator.share) {
    return;
  }
  await navigator.share({
    title: form.title,
    text: form.description,
    url: location.href,
  });
};

const copyLink: OnClickHandler = async (form: Form) => {
  if (!navigator.clipboard) {
    return;
  }

  await navigator.clipboard.writeText(location.href);
  alert("リンクをコピーしました");
};

const DialogMenuItem = ({
  item,
  closeMenu,
  form,
}: {
  item: MenuItem;
  closeMenu: () => void;
  form: DatabaseDetailPageProps["form"];
}) => {
  const theme = useTheme();
  const onClick = () => {
    match(item)
      .with({ kind: "share" }, () => share(form))
      .with({ kind: "copy-link" }, () => copyLink(form))
      .with({ kind: "cancel" }, () => closeMenu())
      .with({ kind: "report" }, () => void 0)
      .exhaustive();
    closeMenu();
  };

  return (
    <div css={dialogMenuItemRootStyle(theme)} onClick={onClick}>
      <item.icon sx={dialogMenuItemIconStyle} fontSize={"small"} />
      <span css={dialogMenuItemTextStyle}>{item.text}</span>
    </div>
  );
};

const dialogMenuItemRootStyle = (theme: Theme) => css`
  display: flex;
  height: 2rem;
  padding: 0.625rem;
  gap: 0.5rem;
  align-items: center;
  cursor: pointer;
  color: ${theme.palette.text.primary};

  &:hover {
    background-color: ${theme.palette.action.hover};
  }
`;

const dialogMenuItemIconStyle = {
  mr: 1,
};

const dialogMenuItemTextStyle = css`
  font-size: 0.75rem;
`;

/**
 * @package
 */
export type { MenuItem };
export default DialogMenuItem;
